import { styled } from "theme/default/styled";
import { setFlexDFFDCF1 } from "theme/setter/setFlexValues/setFlexDFFDCF1";

export const SPaymentActionContent = styled.div`
  position: relative;

  ${setFlexDFFDCF1};
`;
